import { websiteUrl, developByCriteriaURL, teamsUrl } from "utils/env";
import queryString from "query-string";
import Cookies from "js-cookie";
import crypto from "crypto";
import { getSubDomain } from "utils/helperFunctions";
import { getDynamicScoreReportsData } from "./actions";
import { store } from "../../app";

export const linkedInErrorMessaging = (linkedInIntegrationErrorMessage) => {
  switch (linkedInIntegrationErrorMessage) {
    case "Already Integrated":
      return "Login successful. The account has an existing integration, and cannot proceed with the Talent Hub integration.";
    case "Wrong Tier":
      return "Login successful. The account is currently in Essentials tier, and would need to upgrade to Professional Tier in order to enable integrations.";
    case "Insight Portfolio Company":
      return "Login successful. The account is currently in Essentials tier, and would need to upgrade to Professional Tier in order to enable integrations.";
    case "An Error occurred":
    case "Invalid Signature":
      return "Login successful. However, an error occurred when trying to integrate.";
    default:
      return "";
  }
};

export const getVersionName = (hsVersion) => {
  switch (hsVersion) {
    case 0:
      return "Basic";
    case 1:
      return "Essentials";
    case 2:
      return "Professional";
    case 3:
      return "Integrated";
    case 4:
      return "Enterprise";
    case 5:
      return "Suite"; // Talent Success Suite = all platform functionality of Enterprise plus SI
    case 6:
      return "Professional +";
    default:
      return "Essentials";
  }
};

export const setChurnZeroData = (userData, hsVersionName) => {
  const {
    sfAccountId,
    sfContactId,
    companyName,
    expired,
    firstName,
    lastName,
    emailAddress,
  } = userData;

  if (!sfAccountId || !sfContactId) {
    return;
  }

  window.ChurnZero.push(["setContact", `${sfAccountId}`, `${sfContactId}`]);
  window.ChurnZero.push([
    "setAttribute",
    "account",
    {
      Name: companyName,
      IsActive: !expired,
      SoftwareVersion: hsVersionName,
    },
  ]);
  window.ChurnZero.push([
    "setAttribute",
    "contact",
    {
      FirstName: firstName,
      LastName: lastName,
      Email: emailAddress,
      SoftwareVersion: hsVersionName,
    },
  ]);
};

const base64URLEncode = (str) =>
  str
    .toString("base64")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");

const sha256 = (buffer) => crypto.createHash("sha256").update(buffer).digest();

export const getSecuredLoginParams = (emailAddress) => {
  const ranDoCd = `${Math.random()
    .toString(36)
    .slice(2)}+${encodeURIComponent(emailAddress)}`;
  const verifier = base64URLEncode(crypto.randomBytes(32));
  const challenge = base64URLEncode(sha256(verifier));

  return { ranDoCd, verifier, challenge };
};

// idpInfo in Immutable format
export const getIdpLoginRedirectUrl = (
  idpInfo,
  ranDoCd,
  challenge
  // loginFlow, // 'sso' or 'mfa'
  // userEmailAddress = ''
) => {
  // const setupWithAuth0 = idpInfo.get('auth0') && idpInfo.get('auth0').size > 0;

  const queryParams = {
    codeChallengeMethod: "code_challenge_method=S256",
    codeChallenge: `code_challenge=${challenge}`,
    state: `state=${ranDoCd}`,
    clientId: "client_id=",
    scope: "scope=",
    responseType: "response_type=",
  };

  let baseUrl = "";

  /* if (setupWithAuth0) {
    const ssoDetails = idpInfo.get('auth0').get('sso');
    const mfaDetails = idpInfo.get('auth0').get('mfa');

    queryParams.scope += 'email+openid+profile';
    queryParams.responseType += 'code';

    if (loginFlow === 'sso') {
      baseUrl = ssoDetails.get('auth0BaseUrl');

      queryParams.clientId += ssoDetails.get('clientId');
      queryParams.redirectUri = `redirect_uri=${ssoDetails.get('redirectUri')}`; // Auth0 uses 'redirect_uri'
      queryParams.organization = `organization=${ssoDetails.get(
        'organizationId' // only needed by Auth0
      )}`;
    }

    if (loginFlow === 'mfa') {
      baseUrl = mfaDetails.get('auth0BaseUrl');

      queryParams.clientId += mfaDetails.get('clientId');
      queryParams.redirectUri = `redirect_uri=${mfaDetails.get('redirectUri')}`; // Auth0 uses 'redirect_uri'
      queryParams.organization = `organization=${mfaDetails.get(
        'organizationId' // only needed by Auth0
      )}`;
      // if MFA is enabled, append another query parameter 'login_hint', value set to user's email address
      queryParams.login_hint = `login_hint=${encodeURIComponent(
        userEmailAddress
      )}`;
    }
  } else  { */
  baseUrl = idpInfo.get("cognitoBaseUrl");

  queryParams.clientId += idpInfo.get("clientId");
  queryParams.scope += "email+openid+phone+profile";
  queryParams.responseType += "CODE";

  queryParams.redirectUri = `redirectUri=${window.location.href.split("?")[0]}`; // Cognito uses 'redirectUri'
  queryParams.identityProvider = `identity_provider=${idpInfo.get(
    "identityProviderName" // only needed by Cognito
  )}`;
  // }

  const paramString = Object.values(queryParams).join("&");

  return `${baseUrl}?${paramString}`;
};

// idpInfo in JS format
export const getIdpLogoutUrl = (
  idpInfo,
  redirectDestination /* loginType */
) => {
  // const setupWithAuth0 = idpInfo.auth0 && Object.keys(idpInfo.auth0).length > 0;

  // sessionStorage.removeItem('loginType');

  // // return url after logging out auth0
  // if (setupWithAuth0) {
  //   const ssoDetails = idpInfo.auth0.sso;
  //   const mfaDetails = idpInfo.auth0.mfa;

  //   if (loginType === 'sso') {
  //     return ssoDetails.logoutUrl;
  //   }

  //   if (loginType === 'mfa') {
  //     return mfaDetails.logoutUrl;
  //   }
  // }

  // return url after logging out cognito
  let returnUrlAfterLogout = window.location.href.split("?")[0];
  if (redirectDestination === "teaming") {
    returnUrlAfterLogout = teamsUrl;
  } else if (redirectDestination === "root") {
    returnUrlAfterLogout = websiteUrl;
  }

  return `${idpInfo.cognitoBaseUrl.slice(0, -16)}logout?client_id=${
    idpInfo.clientId
  }&logout_uri=${returnUrlAfterLogout}`;
};

export const handleRememberMe = (rememberMe, emailAddress) => {
  if (rememberMe) {
    Cookies.set(
      "_Secure-cog-user",
      {
        emailAddress,
      },
      { expires: 30 }
    );
  } else {
    Cookies.remove("_Secure-cog-user");
  }
};

/**
 * @desc Retrieves Dynamic Score Reports JWT token if available as query parameter or cookie.
 * @return DSR JWT token
 */
export const getDynamicScoreReportsToken = () => {
  const testEventId = window.location.pathname.split("/")[2];

  if (!testEventId) {
    return null;
  }

  const { tkn } = queryString.parse(window.location.search);

  return tkn || Cookies.get(`dynamicScoreReportsTkn_${testEventId}`);
};

/**
 * @desc Initiates authorization and data retrieval flow unique to Dynamic Score Reports.
 * @param tkn - DSR specific JWT token used for data request
 */
export const doDynamicScoreReportsAuth = (tkn) => {
  const testEventId = window.location.pathname.split("/")[2];

  const { testId, source, userAccountId } = queryString.parse(
    window.location.search
  );

  // Create a new URL with only the testEventId to remove any query params if present
  let scoreReportsUrl = `/scoreReports/${testEventId}`;

  // Set a cookie with a unique name and path including the testEventId, and the value as dynamicScoreReportsTkn
  // This ensures viewing multiple dynamic score reports at once will not overwrite cookies for other test events
  Cookies.set(`dynamicScoreReportsTkn_${testEventId}`, tkn, {
    path: scoreReportsUrl,
    domain:
      new URL(websiteUrl).hostname === "localhost"
        ? "localhost"
        : ".criteriacorp.com",
  });

  // If a testId was an original query param, add it back to directly navigate to its test report
  if (testId !== undefined) {
    scoreReportsUrl += `?testId=${testId}`;
  }

  window.history.replaceState({}, "", scoreReportsUrl);

  store.dispatch(
    getDynamicScoreReportsData(testEventId, source, userAccountId)
  );
};

export const determineLoginFlow = (
  status,
  showResetModal,
  showUserVerified
  // loadingIdProvider,
  // identityProviderMode,
  // identityProviderInfo
) => {
  let loginFlow = null;
  if (
    (status === null || status === "passwordReset" || showUserVerified) &&
    !showResetModal
  ) {
    // if (
    //   loadingIdProvider &&
    //   identityProviderMode !== null &&
    //   identityProviderMode === 0 &&
    //   identityProviderInfo.get('mfaEnabled') === 2
    // ) {
    //   // after email is entered,
    //   // if user is MFA-enabled-only, directly push users to mfa log in screen
    //   loginFlow = 'mfaRedirect';
    // } else {
    //   // otherwise let the users decide whether to go with SSO or password
    //   loginFlow = 'passwordLogin';
    // }
    loginFlow = "passwordLogin";
  }
  return loginFlow;
};

export const signInUserIntoDevelopViaSSO = (token) => {
  setCookiesForDevelopLogin(token, true);
  window.location.href = developByCriteriaURL;
  localStorage.clear();
  sessionStorage.clear();
};

export const setCookiesForDevelopLogin = (token, ssoLoginSuccess) => {
  const cookieConfig = {
    path: "/",
    domain: ".criteriacorp.com",
  };
  Cookies.set("critToken", token, cookieConfig);

  if (Cookies.get("ssoLoginSuccess") || ssoLoginSuccess) {
    Cookies.set("ssoLoginSuccess", true, cookieConfig);
  }
};

export const getFreeTrialSubscriptionBannerUTMParams = (companyAccountId) => ({
  content: "free_trial_se",
  campaign: "global_free_tree_banner",
  source: "platform",
  medium: companyAccountId,
});

// Constants for Calendly URLs
const CALENDLY_BASE_URL = "https://calendly.com";
const PLATFORM_DISCUSSION_EVENT = "/criteria-platform-discussion";
const CALENDLY_EVENTS = {
  SMALL_BUSINESS: "/d/cq7j-tyk-nsk/criteria-platform-discussion-sb",
  MID_MARKET: "/d/cntx-ty9-fx2/criteria-platform-discussion-mm",
  ENTERPRISE: "/d/cnz3-5n8-7yb/criteria-platform-discussion-enterprise",
};
const AU_DEFAULT_REP = "criteria-ashley-bramble";

/**
 * Generates appropriate Calendly scheduling URL based on user type and company size
 * @param {boolean} isFreeTrial - Whether user is on free trial
 * @param {Object} rep - Rep information containing CSM and SDR details
 * @param {Object} utmParams - Marketing tracking parameters
 * @param {string} numberOfEmployees - Company size range (e.g. "0-100")
 * @returns {string} Formatted Calendly URL
 */
export const scheduleContactCSMButtonDemoUrl = (
  isFreeTrial,
  rep,
  numberOfEmployees,
  utmParams = {}
) => {
  // Handle missing or incomplete parameters
  const actualRep = rep || { sdr: { firstName: "sales", lastName: "team" } };

  // Format UTM parameters
  const { content = "", campaign = "", source = "", medium = "" } = utmParams;
  const utmParametersLink = `?utm_content=${content}&utm_campaign=${campaign}&utm_source=${source}&utm_medium=${medium}`;

  // Check region
  const isAU = getSubDomain() === "app-au";

  // Case 1: Non-free trial with assigned CSM
  if (!isFreeTrial && actualRep?.csm?.firstName && actualRep?.csm?.lastName) {
    const csmFirstName = actualRep.csm.firstName
      .replace(/[']/g, "")
      .toLowerCase();
    const csmLastName = actualRep.csm.lastName
      .replace(/[']/g, "")
      .toLowerCase();
    return `${CALENDLY_BASE_URL}/criteria-${csmFirstName}-${csmLastName}${utmParametersLink}`;
  }

  // Format SDR names (or use defaults if missing)
  const firstName = actualRep?.sdr?.firstName
    ? actualRep.sdr.firstName.replace(/[^a-zA-Z]/g, "").toLowerCase()
    : "sales";
  const lastName = actualRep?.sdr?.lastName
    ? actualRep.sdr.lastName.replace(/[^a-zA-Z-]/g, "").toLowerCase()
    : "team";

  // Case 2: Free trial with generic "sales team" rep
  if (isFreeTrial && firstName === "sales" && lastName === "team") {
    // For non-AU with employee count, use size-specific links
    if (!isAU && numberOfEmployees) {
      return getEmployeeSizeBasedUrl(numberOfEmployees, utmParametersLink);
    }

    // For AU or missing employee count
    const repName = isAU ? AU_DEFAULT_REP : `criteria-${firstName}-${lastName}`;
    return `${CALENDLY_BASE_URL}/${repName}${PLATFORM_DISCUSSION_EVENT}${utmParametersLink}`;
  }

  // Case 3: Default case (specific SDR)
  return `${CALENDLY_BASE_URL}/criteria-${firstName}-${lastName}${PLATFORM_DISCUSSION_EVENT}${utmParametersLink}`;
};

/**
 * Helper function to get URL based on company size
 * @param {string} employeeCount - Number of employees string (e.g. "0-100")
 * @param {string} utmParams - Formatted UTM parameter string
 * @returns {string} Appropriate Calendly URL
 */
const getEmployeeSizeBasedUrl = (employeeCount, utmParams) => {
  if (employeeCount?.includes("-")) {
    const [minEmployees, maxEmployees] = employeeCount.split("-").map(Number);

    if (minEmployees >= 0 && maxEmployees <= 250) {
      return `${CALENDLY_BASE_URL}${CALENDLY_EVENTS.SMALL_BUSINESS}${utmParams}`;
    }

    if (minEmployees >= 251 && maxEmployees <= 1000) {
      return `${CALENDLY_BASE_URL}${CALENDLY_EVENTS.MID_MARKET}${utmParams}`;
    }
  }

  // Default to enterprise for any other case
  return `${CALENDLY_BASE_URL}${CALENDLY_EVENTS.ENTERPRISE}${utmParams}`;
};
